import { ChangeDetectionStrategy, Component, effect, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertController, IonicModule, ModalController } from '@ionic/angular';
import { IBeverage } from 'app/models/beverage';
import { SearchUntappdPage } from '../search-untappd/search-untappd.page';
import { Beer } from 'app/models/untappdExternal';
import { IBeerStyle } from 'app/models/beerstyle';
import { BeerstyleService } from 'app/services/dal/beerstyle.service';
import * as fromBeerStyle from 'app/state/beer-style';
import { Store } from '@ngrx/store';
import { ISoftUpdate } from 'app/models/softUpdate';
import { ToastService } from 'app/services/toast.service';
import { IExternalApiSettings } from 'app/models/externalApiSettings';
import { SearchBrewfatherPage } from '../search-brewfather/search-brewfather.page';
import { IUnits } from 'app/models/units';
import { UnitsHelper } from 'app/services/units.helper';
import { ICan } from 'app/models/can';
import { IBottle } from 'app/models/bottle';
import { ILocation } from 'app/models/location';
import { ColorHelper } from 'app/services/color.helper';
import * as dateHelper from 'app/helpers/date.helpers';
import { IKeg, IKegVM } from 'app/models/keg';
import { AddKegComponent } from '../add-keg/add-keg.component';
import { EditCanComponent } from '../can/edit-can/edit-can.component';

import { SelectBeerstyleComponent } from '../select-beerstyle/select-beerstyle.component';
import { ImageLabelComponent } from "./image-label/image-label.component";
import * as fromBottle from 'app/state/bottle';
import { BottleService } from 'app/services/dal/bottle.service';
import { NewCanComponent } from '../can/new-can/new-can.component';
import * as fromCan from 'app/state/can';
import { EditBottleComponent } from '../bottle/edit-bottle/edit-bottle.component';
import { NewBottleComponent } from '../bottle/new-bottle/new-bottle.component';
import { RatingComponent } from "./rating/rating.component";
@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    SelectBeerstyleComponent,
    ImageLabelComponent,
    RatingComponent
],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormComponent implements OnChanges {

  @Input() item!: IBeverage | null | undefined;
  @Input() uid!: string | null | undefined;
  @Input() allBeerStyles!: IBeerStyle[] | null | undefined;
  @Input() allKegs!: IKeg[] | null | undefined;
  @Input() attachedKegs!: IKegVM[] | null | undefined;
  @Input() locations!: ILocation[] | null | undefined;

  @Input() unitTypes!: IUnits | null | undefined;
  @Input({ required: true }) isPremium!: boolean | null | undefined;
  @Input({ required: true }) externalApiSettings!: IExternalApiSettings | null | undefined;

  @Output() softUpdateBeverage = new EventEmitter<ISoftUpdate<IBeverage>>();
  @Output() softUpdateKeg = new EventEmitter<ISoftUpdate<IKeg>>();


  @Output() removeKegFromBeverage = new EventEmitter<any>();

  @Output() deleteBeerstyle = new EventEmitter<string>();
  @Output() addBeerstyle = new EventEmitter<any>();

  can = this.store.selectSignal(fromCan.selectCurrentItem);
  bottle = this.store.selectSignal(fromBottle.selectCurrentItem);

  bottles = this.store.selectSignal(fromBottle.selectAllItemsForCurrentBeverage);
  cans = this.store.selectSignal(fromCan.selectAllItemsForCurrentBeverage);
  availableBottles: IBottle[] = [];

  dateHelper = dateHelper;
  form: FormGroup;

  hideAddKegSelectList = true;

  private oldContent!: IBeverage;
  private oldKegs!: IKeg[];

  //cans!: ICan[];

  //#region Date convertions
  bottleDate!: string | null;
  bestBeforeDate!: string | null;
  //#endregion Date convertions

  constructor(
    private alertController: AlertController,
    private colorHelper: ColorHelper,
    private modalController: ModalController,
    private toastService: ToastService,
    private beerstyleService: BeerstyleService,
    private store: Store,
    // public dateHelper: DateHelper,

  ) {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      description: new FormControl(''),
      checkinUrl: new FormControl(''),
      beerStyle: new FormControl(''),
      location: new FormControl(''),
      srm: new FormControl(''),
      fg: new FormControl('1'),
      abv: new FormControl(''),
      ibu: new FormControl(''),
    });

    // effect(() => {
    //   const can = this.can();
    //   if (can?.id) {
    //     this.openEditCanModal(can.id);
    //   }
    // });

    // effect(() => {
    //   const bottle = this.bottle();
    //   if (bottle?.id) {
    //     this.openEditBottleModal(bottle.id);
    //   }
    // });

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['item']?.currentValue) {
      this.setOldContent();
      this.patchForm();

      //#region Date convertions
      this.bottleDate = this.dateHelper.getISOString(this.item?.bottleDate as any);
      this.bestBeforeDate = this.dateHelper.getISOString(this.item?.bestBeforeDate as any);
      //#endregion Date convertions
    }
  }



  private patchForm() {

    if (!this.item) return;

    this.form.patchValue({
      name: this.item.name,
      description: this.item.description,
      checkinUrl: this.item.checkinUrl,
      location: this.item.locationId,
      srm: this.item.srm,
      abv: this.item.abv,
      ibu: this.item.ibu,
      fg: this.item.fg,
    });
  }

  getLocationName(locationId: string) {
    return this.locations?.find(x => x.id === locationId)?.name ?? '';
  }

  updateName() {
    if (this.form.controls['name'].invalid) {
      this.toastService.error("Name is required");
      return;
    }

    if (this.form.controls['name'].value === this.oldContent.name) return;

    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      name: this.form.controls['name'].value
    };
    this.softUpdateCurrentBeverage(this.item.id, update);

  }
  updateDescription() {

    if (this.form.controls['description'].value === this.oldContent.description) return;
    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      description: this.form.controls['description'].value
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }
  updateCheckinUrl() {

    if (this.form.controls['checkinUrl'].value === this.oldContent.checkinUrl) return;
    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      checkinUrl: this.form.controls['checkinUrl'].value
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }
  updateBeerstyle(beerstyle: IBeerStyle) {
    if (beerstyle === this.oldContent.beerStyle) return;

    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      beerStyle: beerstyle
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }
  updateRating(rating: number) {
    if (rating === this.oldContent.rating) return;

    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      rating: rating
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }

  updateLabel(imageUrl: any) {
    if (imageUrl === this.oldContent.image) return;
    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      image: imageUrl
    };

    this.softUpdateCurrentBeverage(this.item.id, update);
  }

  updateLocation(event: any) {

    if (event.detail.value === this.oldContent.locationId) return;

    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      locationId: event.detail.value
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }

  updateSrm() {
    if (this.form.controls['srm'].value === this.oldContent.srm) return;
    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      srm: this.form.controls['srm'].value,
      color: this.getColorFromSrm(this.form.controls['srm'].value)
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }

  updateFg() {
    if (this.form.controls['fg'].value === this.oldContent.fg) return;
    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      fg: this.form.controls['fg'].value,
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }
  updateAbv() {
    if (this.form.controls['abv'].value === this.oldContent.abv) return;
    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      abv: this.form.controls['abv'].value,
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }
  updateIbu() {
    if (this.form.controls['ibu'].value === this.oldContent.ibu) return;
    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      ibu: this.form.controls['ibu'].value,
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }


  //#region Date Functions
  //#region BottleDate
  updateBottleDate(bottleDate: Date | null) {
    if (bottleDate === this.oldContent.bottleDate) return;
    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      bottleDate: bottleDate,
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }
  setDefaultBottleDate() {
    const date = new Date();
    this.bottleDate = dateHelper.toISOString();
    this.updateBottleDate(date);
  }
  setBottleDate(event: any) {
    const date = new Date(event.detail.value);
    if (date) {
      this.updateBottleDate(date);
    }
  }
  deleteBottleDate() {
    this.bottleDate = null;
    this.updateBottleDate(null);
  }
  //#region BottleDate

  //#region Best Before Date
  updateBestBeforeDate(bestBeforeDate: Date | null) {
    if (bestBeforeDate === this.oldContent.bestBeforeDate) return;
    if (!this.item?.id) return;

    const update: Partial<IBeverage> = {
      bestBeforeDate: bestBeforeDate,
    };
    this.softUpdateCurrentBeverage(this.item.id, update);
  }
  setDefaultBestBeforeDate() {
    const date = new Date();
    this.bestBeforeDate = dateHelper.toISOString();
    this.updateBestBeforeDate(date);
  }
  setBestBeforeDate(event: any) {
    const date = new Date(event.detail.value);
    if (date) {
      this.updateBestBeforeDate(date);
    }
  }

  deleteBestBeforeDate() {
    this.bestBeforeDate = null;
    this.updateBestBeforeDate(null);
  }

  //#region Best Before Date
  //#endregion Date Functons


  private getColorFromSrm(srm: number) {
    return this.colorHelper.convertSrmToWebColor(srm);
  }

  //#region Container Modals

  async openAddKegModal(keg: IKeg | null) {

    const oldKeg = { ...keg };
    const allKegs = this.allKegs;
    const locations = this.locations;
    const attachedKegs = this.attachedKegs;

    const modal = await this.modalController.create({
      component: AddKegComponent,
      componentProps: { keg, allKegs, locations, attachedKegs }
    });

    modal.onDidDismiss().then(async (data) => {
      // data.data is undefined when the modal is dismissed via backdrop/close
      // without a payload (BAR-HELPER-2NG) — guard before reaching into .item.
      if (!data.data?.item) {
        return;
      }

      const keg = { ...data.data.item as IKeg };
      const oldBeverageId = keg.beverageId;
      if (oldBeverageId && oldBeverageId !== this.item?.id) {
        const data = {
          beverageId: oldBeverageId,
          kegId: keg.id
        };
        this.removeKegFromBeverage.emit(data);
      }

      if (!oldKeg || oldKeg.id !== keg.id ||
        oldKeg.tapDate !== keg.tapDate ||
        oldKeg.bestBeforeDate !== keg.bestBeforeDate ||
        oldKeg.notificationDate !== keg.notificationDate ||
        oldKeg.locationId !== keg.locationId ||
        oldKeg.notificationMessage !== keg.notificationMessage
      ) {

        if (!keg.id) return;

        if (!this.item?.id) {
          return;
        }

        const updateKegData: Partial<IKeg> = {
          beverageId: this.item?.id,
          locationId: keg.locationId,
          tapDate: keg.tapDate != null ? new Date(keg.tapDate) : null,
          bestBeforeDate: keg.bestBeforeDate != null ? new Date(keg.bestBeforeDate) : null,
          notificationDate: keg.notificationDate != null ? new Date(keg.notificationDate) : null,
          notificationMessage: keg.notificationMessage,
          cleanDate: null
        }
        this.softUpdateCurrentKeg(keg.id, updateKegData);

      }
    });

    return await modal.present();
  }

  async openAddBottleModal() {
    const modal = await this.modalController.create({
      component: NewBottleComponent,
    });
    modal.onDidDismiss().then((response) => {
      if (response.role === 'open-edit' && response.data.id) {
        this.openEditBottleModal(response.data.id);
      }
    });

    return await modal.present();
  }

  async openEditBottleModal(id: string) {
    this.store.dispatch(fromBottle.setItem({ id }));
    const modal = await this.modalController.create({
      component: EditBottleComponent,
    });
    return await modal.present();
  }

  async openAddCanModal() {
    const modal = await this.modalController.create({
      component: NewCanComponent,
    });
    modal.onDidDismiss().then((response) => {
      if (response.role === 'open-edit' && response.data.id) {
        this.openEditCanModal(response.data.id);
      }
    });
    return await modal.present();
  }

  async openEditCanModal(id: string) {
    this.store.dispatch(fromCan.setItem({ id }));
    const modal = await this.modalController.create({
      component: EditCanComponent,
      componentProps: {
        id: id
      }
    });
    return await modal.present();
  }


  async confirmDeleteBottle(bottle: IBottle) {
    const alert = await this.alertController.create({
      header: "Delete bottle",
      message: `Are you sure you want to delete ${bottle.name}?`,
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: 'alert-button-cancel'
        },
        {
          text: "Delete",
          cssClass: 'alert-button-delete',
          handler: () => {
            this.deleteBottle(bottle);
          },
        },
      ],
    });

    await alert.present();
  }



  async confirmDeleteCan(can: ICan) {
    const alert = await this.alertController.create({
      header: "Delete can",
      message: `Are you sure you want to delete ${can.name}?`,
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: 'alert-button-cancel'
        },
        {
          text: "Delete",
          cssClass: 'alert-button-delete',
          handler: () => {
            this.deleteCan(can);
          },
        },
      ],
    });

    await alert.present();
  }




  deleteBottle(bottle: IBottle) {
    this.store.dispatch(fromBottle.deleteItem({ id: bottle.id || '' }));
  }


  deleteCan(can: ICan) {
    this.store.dispatch(fromCan.deleteItem({ id: can.id || '' }));
  }


  trackKegById(index: number, item: IKeg) {
    return item.id;
  }

  async confirmDeleteKeg(keg: IKeg, index: number) {
    const alert = await this.alertController.create({
      header: "Delete keg",
      message: `Are you sure you want to delete ${keg.name}?`,
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: 'alert-button-cancel',
        },
        {
          text: "Delete",
          cssClass: 'alert-button-delete',
          handler: () => {
            this.deleteKeg(keg, index);
          },
        },
      ],
    });

    await alert.present();
  }



  async deleteKeg(keg: IKeg, index: number) {
    const data = {
      beverageId: this.item?.id,
      kegId: keg.id
    };
    this.removeKegFromBeverage.emit(data);
  }






  //endregion Container Modals
  //#region Untappd & Brewfahter
  async openSeachModalUntappd() {
    const modal = await this.modalController.create({
      component: SearchUntappdPage,
    });

    modal.onDidDismiss().then(async (data) => {
      const item = data.data;
      if (!item) {
        return;
      }

      const beer = item.beer as Beer;
      if (!beer) {
        return;
      }

      if (!this.item?.id) return;

      const beverage: IBeverage = {
        barId: this.item.barId,
        inventoryType: "Beer",
        name: this.item.name ? this.item.name : beer.beer_name,
        description: this.item.description ? this.item.description : beer.beer_description,
        beerStyle: this.item.beerStyle ? this.item.beerStyle : this.setBeerStyleForUntappd(beer.beer_style),
        ibu: this.item.ibu ? this.item.ibu : beer.beer_ibu,
        fg: this.item.fg ? this.item.fg : 1,
        abv: this.item.abv ? this.item.abv : beer.beer_abv,
        image: this.item.image ? this.item.image : beer.beer_label,
        bottleDate: null,
        bestBeforeDate: null,
        checkinUrl: this.item.checkinUrl ? this.item.checkinUrl : `https://untappd.com/qr/beer/${beer.bid}`,
      };
      this.softUpdateCurrentBeverage(this.item.id, beverage);
    });

    return await modal.present();
  }

  async openSeachModalBrewfather() {
    const modal = await this.modalController.create({
      component: SearchBrewfatherPage,
      componentProps: {
        beer: {},
      },
    });

    modal.onDidDismiss().then((data) => {

      const item = data.data;
      if (!item) {
        return;
      }
      if (!this.item?.id) return;

      const beer = item.beer as IBeverage;

      const beverage: Partial<IBeverage> = {
        name: beer.name,
        abv: beer.abv,
        bottleDate: beer.bottleDate,
        fg: beer.fg,
        ibu: beer.ibu ?? item.ibu,
        srm: beer.srm,
        color: beer.srm ? this.getColorFromSrm(beer.srm) : '',
        beerStyle: beer.beerStyle ? this.setBeerStyleForBrewfather(beer.beerStyle) : undefined,
      };

      this.softUpdateCurrentBeverage(this.item.id, beverage);
    });

    return await modal.present();
  }
  //#endregion Untappd & Brewfather

  //#region Untappd & Brewfather Private functions
  private setBeerStyleForUntappd(name: string): IBeerStyle {
    const item = this.allBeerStyles?.find((x) => x.name === name);
    if (!item) {
      const newId = this.beerstyleService.getNewId();
      const beerStyle = {
        barId: "",
        id: newId,
        name,
      };
      this.store.dispatch(fromBeerStyle.addItem({ id: newId, item: beerStyle }));
      return beerStyle;
    }
    return item;
  }

  private setBeerStyleForBrewfather(beerstyle: IBeerStyle): IBeerStyle {
    const item = this.allBeerStyles?.find((x) => x.name === beerstyle.name);
    if (!item) {
      const newId = this.beerstyleService.getNewId();
      const beerStyle = {
        ...beerstyle,
        barId: '',
      };
      this.store.dispatch(fromBeerStyle.addItem({ id: newId, item: beerStyle }));
      return beerStyle;
    }
    return item;
  }
  //#endregion Untappd & Brewfather Private functions

  //#region Cans and Bottles
  // private updateAvailableBottles() {
  //   this.populateAvailableBottles();


  //   if (!this.bottles()) {
  //     return;
  //   }

  //   // this.item.bottles.forEach((bottle: IBottle) => {
  //   //   this.bottles.forEach((b) => {
  //   //     if (b.size == bottle.size) {
  //   //       this.bottles.splice(this.bottles.indexOf(b), 1);
  //   //     }
  //   //   });
  //   // });
  // }

  // private updateAvailableCans() {
  //   this.populateAvailableCans();
  //   if (!this.item) {
  //     return;
  //   }

  //   if (!this.item.cans) {
  //     return;
  //   }

  //   this.item.cans.forEach((can) => {
  //     this.cans.forEach((b) => {
  //       if (b.size == can.size) {
  //         this.cans.splice(this.cans.indexOf(b), 1);
  //       }
  //     });
  //   });
  // }

  // private populateAvailableBottles() {

  //   if (!this.unitTypes) return;

  //   var volume = this.unitHelper.getUnit(this.unitTypes.bottles);
  //   if (volume.system === "imperial") {
  //     this.availableBottles.push(
  //       { beverageId: this.item?.id ?? '', barId: this.item?.barId ?? '', size: 248, type: "imperial", name: "8.4oz", count: 0, bestBeforeDate: undefined },
  //       { beverageId: this.item?.id ?? '', barId: this.item?.barId ?? '', size: 354, type: "imperial", name: "12oz", count: 0, bestBeforeDate: undefined },
  //       { beverageId: this.item?.id ?? '', barId: this.item?.barId ?? '', size: 473, type: "imperial", name: "16oz", count: 0, bestBeforeDate: undefined },
  //       { beverageId: this.item?.id ?? '', barId: this.item?.barId ?? '', size: 568, type: "imperial", name: "19.2oz", count: 0, bestBeforeDate: undefined }
  //     );
  //   } else {
  //     this.availableBottles.push(
  //       { beverageId: this.item?.id ?? '', barId: this.item?.barId ?? '', size: 750, type: "metric", name: "0.75l", count: 0, bestBeforeDate: undefined },
  //       { beverageId: this.item?.id ?? '', barId: this.item?.barId ?? '', size: 500, type: "metric", name: "0.50l", count: 0, bestBeforeDate: undefined },
  //       { beverageId: this.item?.id ?? '', barId: this.item?.barId ?? '', size: 440, type: "metric", name: "0.44l", count: 0, bestBeforeDate: undefined },
  //       { beverageId: this.item?.id ?? '', barId: this.item?.barId ?? '', size: 330, type: "metric", name: "0.33l", count: 0, bestBeforeDate: undefined },
  //       { beverageId: this.item?.id ?? '', barId: this.item?.barId ?? '', size: 250, type: "metric", name: "0.25l", count: 0, bestBeforeDate: undefined }
  //     );
  //   }
  // }
  // private populateAvailableCans() {
  //   if (!this.unitTypes) return;

  //   this.cans = [];
  //   var volume = this.unitHelper.getUnit(this.unitTypes.cans);
  //   if (volume.system === "imperial") {
  //     this.cans.push(
  //       { beverageId: '', barId: '', size: 354, type: "imperial", name: "12oz", count: 0 },
  //       { beverageId: '', barId: '', size: 651, type: "imperial", name: "22oz", count: 0 },
  //       { beverageId: '', barId: '', size: 1892, type: "imperial", name: "64oz", count: 0 }
  //     );
  //   } else {
  //     this.cans.push(
  //       { beverageId: '', barId: '', size: 500, type: "metric", name: "0.50l", count: 0 },
  //       { beverageId: '', barId: '', size: 440, type: "metric", name: "0.44l", count: 0 },
  //       { beverageId: '', barId: '', size: 330, type: "metric", name: "0.33l", count: 0 },
  //       { beverageId: '', barId: '', size: 250, type: "metric", name: "0.25l", count: 0 }
  //     );
  //   }
  // }


  //#endregion Cans and Bottles



  private softUpdateCurrentBeverage(beverageId: string, item: Partial<IBeverage>) {
    const update: ISoftUpdate<IBeverage> = {
      id: beverageId,
      data: item,
      uid: this.uid ?? ''
    };
    this.softUpdateBeverage.emit(update);
  }


  private softUpdateCurrentKeg(kegId: string, item: Partial<IKeg>) {
    const update: ISoftUpdate<IKeg> = {
      id: kegId,
      data: item,
      uid: this.uid ?? ''
    };
    this.softUpdateKeg.emit(update);
  }

  private setOldContent() {
    this.oldContent = JSON.parse(JSON.stringify(this.item));
  }

}
